/**
 *
 * @desc 微前端-子应用
 * @author zhuzj
 *
 */
import React from "./react.shim";
import {GlobalContext} from './GlobalContext';

export default class SmallApplication extends React.PureComponent {

    render() {
        const {children,className,style,tinperNextRole,...other} = this.props;

        return (
            <GlobalContext.Consumer>
                {(appContext)=>{
                    console.log(`[TNE]小应用执行渲染: ${appContext.currProviderName}!${appContext.currProviderEntry}`,appContext);
                    const code = `<SmallApplication>
                                    {(appContext)=>{
                                        return <div>This is MyApp</div>
                                    }}
                                </SmallApplication>`;
                    const classes = [appContext.currProviderName];
                    className && classes.push(className);
                    const styles = Object.assign({width:'100%',height:'100%',position:'relative'},style);
                    if(typeof children !== 'function'){
                        return `[TNE]SmallApplication组件的children必须为function类型，例如：${code}`
                    };
                    const childView = children(appContext);
                    if(React.isValidElement(childView)){
                        return <div className={classes.join(' ')} style={styles} {...(tinperNextRole===false?{}:{'tinper-next-role':"container"})} {...other}>{childView}</div>;
                    }else{
                        return `[TNE]SmallApplication组件的需返回有效的React元素，例如：${code}`;
                    }
                }}
            </GlobalContext.Consumer>
        );
    }

}

